import BaseService from '@/config/base-service'

class SelfieHiveService extends BaseService {
  constructor() {
    super(`hive-liveness-portal`)
  }

  getSessionTokenSelfieFace(key, agent) {
    const config = {
      headers: {
        'x-device-key': key,
        'x-user-agent': agent
      }
    }
    return this.get(`selfie-face/session-token`, config)
  }

  validSelfieTransaction(payload, deviceToken) {
    const payloadFormData = new FormData()
    payloadFormData.append('file', payload, 'bdata')
    payloadFormData.append('deviceToken', deviceToken)

    const config = {
      params: {
        ts: new Date().getTime()
      },
      headers: {
        'X-DEBUG': 'hive-liveness-portal',
        'Content-Type': 'multipart/form-data'
      }
    }

    return this.post(payloadFormData, `selfie/valid`, config)
  }

  validSelfieFaceTransaction(payload, agent) {
    const headers = {
      'X-User-Agent': agent
    }
    return this.post(payload, `selfie/face/valid`, { headers })
  }

  processFaceTecRequest(payload) {
    return this.post(payload, `selfie/face/sdk`).then((resp) => {
      return resp
    })
  }
}

export default new SelfieHiveService()
